module.exports = __webpack_public_path__ + "static/Cindy-97b0f177767eaf1c79bc1e25492d1394.png";